// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2yL7n","header":"Messages_header__3wwPr"};